import type {
	AiQueryRequest,
	AiQueryRequestUrlParams,
	GetCompanyAISettingsResponse,
	HasAccessibleDocumentsResponse,
	PatchCompanyAISettingsRequest,
	PatchCompanyAISettingsResponse,
	PostCompanyAISettingsRequest,
	PostCompanyAISettingsResponse,
	UserErrorResponseJson,
} from "@performyard/service-contracts";

import internalRequest from "./internal-base-request";

export const getCompanyAISettings = async () => {
	const [response] = await internalRequest<GetCompanyAISettingsResponse>("/v1/ai/settings");
	return response;
};

export const postCompanyAISettings = async (aiSettings: PostCompanyAISettingsRequest) => {
	const [response] = await internalRequest<PostCompanyAISettingsResponse>("/v1/ai/settings", {
		method: "POST",
		body: JSON.stringify({ ...aiSettings }),
	});

	return response;
};

export const patchCompanyAISettings = async (aiSettings: PatchCompanyAISettingsRequest) => {
	const [response] = await internalRequest<PatchCompanyAISettingsResponse>("/v1/ai/settings", {
		method: "PATCH",
		body: JSON.stringify({ ...aiSettings }),
	});

	return response;
};

export const getHasAccessibleDocuments = async (): Promise<HasAccessibleDocumentsResponse> => {
	const [response] = await internalRequest<HasAccessibleDocumentsResponse>("/v1/ai/documents/accessible");
	return response;
};

type AiQueryRequestProps = AiQueryRequest & AiQueryRequestUrlParams;

export const postQueryAi = async <TResponse>(
	props: AiQueryRequestProps
): Promise<TResponse | UserErrorResponseJson> => {
	// Start the POST request to the streaming endpoint we need to catch because internalRequest throws an error and doesn't handle it properly
	try {
		const [response] = await internalRequest<TResponse | UserErrorResponseJson>(
			`/v1/ai/prompt?retry=${props.retry || false}&responseStyle=${props.responseStyle || "text"}`,
			{
				method: "POST",
				body: JSON.stringify(props),
			}
		);

		return response;
	} catch (error) {
		return {
			message: "Something went wrong",
			details: [error instanceof Error ? error.message : "Unknown error"],
		};
	}
};
